var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark"},_vm._l((100),function(item){return _c('div',{key:item,staticClass:"block"},_vm._l((30),function(item2){return _c('div',{key:item2,staticClass:"item"},[_c('div',{staticClass:"p"},[_vm._v(" "+_vm._s(_vm.nikeName)+" ")]),_c('div',{staticClass:"p"},[_vm._v(" "+_vm._s(_vm.time)+" ")])])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }